meedy.directive('esCookieNotice', [
  function () {
    var definition = {
      restrict: 'E',
      replace: false,
      transclude: false,
      scope: {},
      templateUrl: 'meedy/application/directive/esCookieNotice/template/es-cookie-notice.html',
      // controller: ['$scope', '$cookies', 'objectHelper', function ($scope, $cookies, objectHelper) {
      //   $scope.Enum = Enum;
      //
      //   var cookieValue = $cookies.get('cookies-notice');
      //   $scope.showCookies = (cookieValue=='accepted')? false : true;
      //   $scope.hideCookies = function () {
      //     $cookies.put('cookies-notice', 'accepted');
      //     $scope.showCookies = false;
      //   }
      //
      // }],
      controller: ['$scope', '$cookies', function ($scope, $cookies ) {
        $scope.Enum = Enum;

        var cookieValue = $cookies.get('cookies-notice');
        $scope.showCookies = (cookieValue=='accepted')? false : true;
        $scope.hideCookies = function () {
          $cookies.put('cookies-notice', 'accepted');
          $scope.showCookies = false;
        }

      }]
    };
    
    return definition;
  }
]);